// Two-way resource base: '/files' (integrated / single-domain mode, served
// same-origin by the backend) or the original absolute static host. The
// default keeps original-path behaviour so this code stays merge-compatible
// with upstream lodestar-app; .env.production opts this repo into /files.
export const STATIC_RESOURCE_BASE = process.env.REACT_APP_STATIC_RESOURCE_BASE || 'https://static.kolable.com'
